import React from 'react';
import styled from 'styled-components';

import SectionContainer from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';

const Iframe = styled.iframe`
  border: 0;
  display: block;
  max-width: 700px;
  width: 100%;
  height: 250px;
  padding: 0px;
  margin: ${({ theme }) => theme.spacing(6, 'auto')};
`;

const Report = () => (
  <SectionContainer>
    <SectionTitle title="佐賀県でのおてつたびレポート" subtitle="REPORT" />
    <Iframe
      className="note-embed"
      src="https://note.com/embed/notes/n5f9f8542901e"
    />
    <script async src="https://note.com/scripts/embed.js" />
  </SectionContainer>
);

export default Report;
